function listenerGlobalEvents(type, selector, callback) {
  document.addEventListener("click", (e) => {
    if (e.target.matches(selector)) callback(e);
  });
}

//all add-to-cart handler
// var product_id_added = '34';
// var showzero = 0 ;

function emptycarttrue(work) {
  if (work === "add") {
    document
      .querySelector(".prpwebs-popup-cart-load")
      .classList.add("emptycarttrue");
    document
      .querySelector(".prpwebs-drawer-checkout")
      .classList.add("emptycarttrue");
    document.querySelector(".prpwebs-empty-cart").style.display = "block";
  } else if (work === "remove") {
    document
      .querySelector(".prpwebs-popup-cart-load")
      .classList.remove("emptycarttrue");
    document
      .querySelector(".prpwebs-drawer-checkout")
      .classList.remove("emptycarttrue");
    document.querySelector(".prpwebs-empty-cart").style.display = "none";
  } else {
    return;
  }
}

//get cart items for cart drawer
async function getCartProducts() {
  // loader image show and remove on cart drawer
  const loaderImg = document.querySelector(".cart_loader_img");
  loaderImg ? loaderImg.classList.add("active") : "";

  let cartHtml = "";

  // remove emptycarttrue class on cart drawer app
  emptycarttrue("remove");

  // api call and create html
  await fetch("/cart.js", { method: "GET" })
    .then((response) => response.json())
    .then((cart) => {
      // now have access to Shopify cart object
      let carp_url = "";
      let carp_fImage = "";
      let carp_title = "";
      let carp_vtitle = "";
      let carp_itemId = "";
      let carp_itemVid = "";
      let carp_quantity = "";
      let carp_orginalPrice = "";
      let carp_finalPrice = "";
      let cartitems = cart.items;
      let itemindex = 0;

      document.querySelector(".cart-count-js").innerHTML = cart.item_count;

      for (let key in cartitems) {
        itemindex = itemindex + 1;
        let item = cartitems[key];
        let itemID = key + 1;
        carp_url = item.url;
        carp_fImage = item.image;
        carp_title = item.product_title;
        carp_itemId = item.id;
        carp_itemVid = item.variant_id;
        carp_quantity = item.quantity;
        carp_orginalPrice = item.price;
        carp_orginalPrice = carp_orginalPrice / 100;
        carp_orginalPrice = carp_orginalPrice.toFixed(2);
        carp_finalPrice = item.final_price;
        carp_finalPrice = carp_finalPrice / 100;
        carp_finalPrice = carp_finalPrice.toFixed(2);
        //console.log(item.variant_title);
        if (item.variant_title === null) {
          //console.log('hello from null');
          carp_vtitle = " ";
        } else {
          if (item.variant_title != "Default Title") {
            carp_vtitle = item.variant_title;
          } else {
            carp_vtitle = " ";
          }
        }

        let prpwebs_quantity = `<div class="prpwebs-item-cart-qty prpwebs-item-${carp_itemId} quantity center">
                              <div class="js-qty__adjust_prpwebs1 prpwebs-cart-plus-minus" data-quantity="${carp_quantity}" data-id="${carp_itemId}" data-line="1">
                                  <div class="prpwebs-dec prpwebs-qty button js-qty__adjust_prpwebs js-qty__adjust--minus quantity__minus">
                                      <span class="prpwebs-minus-symbol" id="minus-${itemindex}" onclick=minusItem(event,${itemindex},${carp_itemId})>-</span>
                                  </div>
                                   <label for="inputQuantity_${itemindex}" class="visually-hidden">Quantity</label>
                                  <input type="text" value="${carp_quantity}" class="text quantity js-qty__num quantity__input prpwebs-qty-inputbox" data-id="${carp_itemId}" id="inputQuantity_${itemindex}" disabled>

                                 <div class="prpwebs-inc prpwebs-qty button js-qty__adjust_prpwebs js-qty__adjust--plus quantity__plus">
                                      <span class="prpwebs-plus-symbol" id="plus-${itemindex}" onclick=plusItem(event,${itemindex},${carp_itemId})>+</span>
                                </div>
                              </div>  
                          </div>`;
        console.log(
          `${parseFloat(carp_orginalPrice)} > ${parseFloat(carp_finalPrice)}`
        );
        if (parseFloat(carp_orginalPrice) > parseFloat(carp_finalPrice)) {
          var amount_real =
            "<del>$" +
            (carp_orginalPrice * carp_quantity * 1).toFixed(2) +
            "</del> $" +
            (carp_finalPrice * carp_quantity * 1).toFixed(2);
          //console.log(amount_real);
        } else {
          var amount_real =
            "$" + (carp_orginalPrice * carp_quantity * 1).toFixed(2);
        }
        cartHtml +=
          `     
          <div class="prpwebs-item-cart-content" id="item-${itemindex}">
                  <div class="prpwebs-item-content-variants">
                       <div class="prpwebs-item-cart-image">
                              <a href="${carp_url}"><img class="prpwebs-cart-image" src="${carp_fImage}"  alt="${carp_title}"/></a>
                      </div> 
                <div class="prpwebs-item-cart-description">
                  <div class="prpwebs-item-close">
                      <a href="javascript:void(0);" class="prpwebs-remove-item" data-id="${carp_itemId}" aria-label="Remove item" onclick="removItemCart(${carp_itemId},'item-${itemindex}')">
                          <span class="prpwebs-close-btn">&times;</span>
                      </a>
                  </div>  
                <div class="prpwebs-content-product-and-variant-title">  
                      <a href="${carp_url}" class="prpwebs-product-title gt_america_bold">  ${carp_title}  </a>  
          <span class="prpwebs-variant-title gt_america">${carp_vtitle}</span>  
                      <div class="prpwebs-propertie-content"></div>  
                </div> 
                <div class="prpwebs-content-quantity-price">

                      <div class="prpwebs-item-cart-content-quantity">  
						
                          ${prpwebs_quantity}

                      </div>

                      <div class="prpwebs-cart-content-price cartitem-id-${carp_itemId}">  
                            <span class="prpwebs-compare-at-price"></span>
                            <span class="prpwebs-price-total gt_america_bold prpwebs-desktop"> 
							<span class="money" id="inputPrice_${itemindex}" data-current_price="${item.final_price}" data-main_price="${item.price}">` +
          amount_real +
          `</span></span>      
                      </div>
                </div>
                </div>
                </div>
                </div> `;
      }
    })
    .finally(function () {
      // remove load img
      const loaderImgRemove = document.querySelector(".cart_loader_img");
      loaderImgRemove ? loaderImgRemove.classList.remove("active") : "";

      //  update cart items on cart drawer and open drawer
      document.querySelector(".prpwebs_cartitems").innerHTML = cartHtml;
      document
        .querySelector(".prpwebs-popup-drawer-load")
        .classList.add("active");
    });
}

// on click on pw-btn class element on all type of pages ( collection, product and other pages
const pw_btn = document.querySelector("body");
pw_btn.addEventListener("click", async function (e) {
  const pwBtnCurrent = e.target.closest('form[action="/cart/add"] .pw-btn');
  if (pwBtnCurrent) {
    let btnText = pwBtnCurrent.querySelector(".atc-btn-text").innerHTML;

    //   	 adding process and show message on button
    pwBtnCurrent.querySelector(".atc-btn-text").innerHTML = "adding...";

    // add class on current click
    pwBtnCurrent.classList.add("current_add");

    let productID = "";
    form_array = [...pwBtnCurrent.closest("form").querySelectorAll("input")];

    // get product variant id on product page and other page.
    if (window.templateName.includes("product")) {
      var quantity = pwBtnCurrent
        .closest("form")
        .querySelector(".quantity__input").value;
      let pid = form_array.find((item) => item.name === "id");
      productID = pid["value"];
    } else {
      productID = form_array[0].value;
    }

    // product quantity and product variants id for product page and other pages.
    if (quantity == undefined) {
      quantity = 1;
    }

    //  /cart/add.js api call for adding product in cart
    let formData = {
      items: [
        {
          quantity: quantity,
          id: productID,
        },
      ],
    };

    await fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error("Something went wrong. Please try again");
      })
      .then(async (data) => {
        let lodinghr = document.querySelector(".loadinghr");
        lodinghr.style.display = "block";

        await getCartProducts();
        pwBtnCurrent.querySelector(".atc-btn-text").innerHTML = "Add To Cart";
        changeValues();

        document
          .querySelector(".prpwebs-popup-drawer-load")
          .classList.add("active");
        document.querySelector("body").classList.add("prpwebs-cart-open");
      })
      .catch((error) => {
        alert(error);
        pwBtnCurrent.querySelector(".atc-btn-text").innerHTML = "Add To Cart";
      });
  }
});

//get cart items for cart drawer function
const checkCart = async function () {
  const response = await fetch("/cart.js", { method: "GET" });
  const data = await response.json();

  if (data.items.length == 0) {
    emptycarttrue("add");
  } else {
    emptycarttrue("remove");
  }
};

// // call function to update cart drawer based on item
checkCart();

//change subtotal prices
async function changeValues() {
  await fetch("/cart.js", { method: "GET" })
    .then((response) => response.json())
    .then((data) => {
      createupsellItem(data);
      let total_cart = data.total_price / 100;
      total_cart = total_cart.toFixed(2);
      document.querySelector(".cart__subtotal").innerHTML = `$${total_cart}`;
      document.querySelector(".cart-count-js").innerHTML = data.item_count;
      //  show message of free shipping above $49
      if (data.total_price < 4900) {
        //                 console.log("hhhh less 49");
        let ship_amt = (4900 - data.total_price) / 100;
        ship_amt = ship_amt.toFixed(2);

        document.querySelector(
          ".shipping_count_div #shipping_count_data"
        ).innerHTML = `YOU ARE <span class="shipamount gt_america_bold">$${ship_amt}</span> AWAY FROM FREE SHIPPING`;
        document
          .querySelector(".shipping_count_div #cartprogressbar")
          .setAttribute("value", data.total_price / 100);
      } else {
        //               console.log("hhhh greater 49");
        document.querySelector(
          ".shipping_count_div #shipping_count_data"
        ).innerHTML = `YOUR BAG QUALIFIES FOR FREE SHIPPING`;
        document
          .querySelector(".shipping_count_div #cartprogressbar")
          .setAttribute("value", data.total_price / 100);
      }

      if (data.total_price < data.original_total_price) {
        document.querySelector(
          ".prpwebs-amount-sub-total .money-original"
        ).innerHTML = Shopify.formatMoney(data.original_total_price);
      }
    });
}

//check cart items in upsell
function checkItemInUpsell(data) {
  let items = data.items;
  let currentUpsellItems = localStorage.getItem("currentUpsellItems");
  let suggestionsarray = (currentUpsellItems || "").split("|");

  //all handles
  let extraUpsellItems = localStorage.getItem("productHandles");
  extraUpsellItems = (extraUpsellItems || "").replace(/['"]+/g, "");
  extraUpsellItems = extraUpsellItems.split("|");

  suggestionsarray = suggestionsarray.concat(extraUpsellItems);
  suggestionsarray = suggestionsarray.filter(
    (v, i) => suggestionsarray.indexOf(v) == i
  );

  let uniquesuggestion = [];
  let count = 1;

  for (let itemdata in items) {
    let item = items[itemdata];

    if (suggestionsarray.includes(item.handle)) {
      let index = suggestionsarray.indexOf(item.handle);
      if (index > -1) {
        suggestionsarray.splice(index, 1);
      }
    }

    if (items.length == count) {
      localStorage.setItem("allsuggestions", JSON.stringify(suggestionsarray));
      return true;
    }
    count = count + 1;
  }

  return true;
}

//upsell item insert after add to cart
function insertupsellItems() {
  let upsellhtml = localStorage.getItem("upsellItemHtml");
  let lodinghr = document.querySelector(".loadinghr");
  lodinghr.style.display = "none";

  if (upsellhtml != "") {
    document.querySelector(".prpwebs-recommendations-data").innerHTML =
      upsellhtml;
  } else {
    console.log("empty");
    let autoRecomm = document.querySelector(".empty-bought-together").innerHTML;
    document.querySelector(".prpwebs-recommendations-data").innerHTML =
      autoRecomm;
  }
  // setTimeout(sample_product, 2000);
}

// Sample Product select function
// function sample_product() {
//   var one = "39393805238361";
//   var swatch_selected_1 = "";
//   var sampleOne = document.querySelectorAll(
//     ".prpwebs-variants-swipper .product-type-swatches__list.sample-1 .shade-swatch"
//   );

//   Array.from(sampleOne).forEach((link) => {
//     link.addEventListener("click", function () {
//       one = this.getAttribute("data-product-id");
//       swatch_selected_1 = this.getAttribute("data-product-title");
//       document.querySelector(".sample_select_1").textContent =
//         swatch_selected_1;
//       document
//         .querySelector(".sample_add_button")
//         .setAttribute("data-product-id", one);
//       $(this)
//         .addClass("is-selected")
//         .siblings(".sample-1 .shade-swatch")
//         .removeClass("is-selected");
//       console.log(one);
//     });
//   });
// }

// sample_product();

function jsonCallShopify(suggestions, index, counterForCart, upsellHtml, type) {
  var index = index;
  var itemSelected = suggestions[index];
  var suggestions = suggestions;
  var counterForCart = counterForCart;
  var upsellHtml = upsellHtml;
  var selvariantid = 0;
  if (counterForCart == 1) {
    upsellHtml += `<!-- Gloss Up Sheer Finish Gloss Product -->
    <div class="prpwebs-products-dynamic-stacked">
      <div class="prpwebs-swiper-slide">
        <div class="prpwebs-content-product-slide-cart">
          <div class="prpwebs-product-content-image-swipper">
            <a href="https://thelipbar.com/products/sheer-finish-lip-gloss?variant=39886859108441"
              ><img
                class="prpwebs-cart-image"
                src="https://cdn.shopify.com/s/files/1/1919/5103/products/gloss_minimalist_swatch_7609cb88-0e00-42ff-983a-6b9e624ff551_150x.jpg?v=1766127033"
                alt="Gloss"
            ></a>
          </div>
          <div class="prpwebs-content-title-price-swiper">
            <div class="prpwebs-title-swiper">
              <a
                href="https://thelipbar.com/products/sheer-finish-lip-gloss?variant=39886859108441"
                class="prpwebs-product-title"
                >Gloss Up Sheer Finish Gloss</a
              >
              <span class="prpwebs-variant-title">Minimalist</span>
            </div>
            <div class="prpwebs-content-price-swiper">
              <div class="prpwebs-price-sw">
                <span class="money"> $15.00</span>
              </div>
            </div>
            <form action="/cart" class="add-upsell-items upsell-cart">
              <div class="prpwebs-variants-swipper">
                <div class="prpwebs-qty-upsell">
                  <div class="prpwebs-item-cart-content-quantity">
                    <div class="prpwebs-item-cart-qty prpwebs-item-32329469100121 quantity center">
                      <div class="js-qty__adjust1 prpwebs-cart-plus-minus" data-quantity="1" data-id="39886859108441">
                        <div class="prpwebs-dec prpwebs-qty button js-qty__adjust_prpwebs js-qty__adjust--minus quantity__minus">
                          <span class="prpwebs-minus-symbol">-</span>
                        </div>
                       <label for="updates_323294691001211" class="visually-hidden">Quantity</label>
                        <input
                          type="text"
                          value="1"
                          class="text quantity js-qty__num quantity__input prpwebs-qty-inputbox"
                          data-id="39886859108441"
                          id="updates_323294691001211"
                          name="quantity"
                        >

                        <div class="prpwebs-inc prpwebs-qty button js-qty__adjust_prpwebs js-qty__adjust--plus quantity__plus">
                          <span class="prpwebs-plus-symbol">+</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="prpwebs-upsell-add">
                <button type="button" name="id" class="prpwebs-upsell-add-to-cart" data-product-id="39886859108441">
                  <span class="prpwebs-add--to--cart">Add</span>
                  <span class="prpwebs--loading">
                    <i class="fa fa-circle-o fa-spin fa-1x fa-fw margin-bottom"></i>
                  </span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- End Gloss Up Sheer Finish Gloss Product -->
    <!-- Straight Line Eyeliner + Sharpener Duo Product -->
    <div class="prpwebs-products-dynamic-stacked">
      <div class="prpwebs-swiper-slide">
        <div class="prpwebs-content-product-slide-cart">
          <div class="prpwebs-product-content-image-swipper">
            <a href="https://thelipbar.com/products/straight-line-eyeliner-sharpener-duo?variant=40895390416985"
              ><img
                class="prpwebs-cart-image"
                src="https://cdn.shopify.com/s/files/1/1919/5103/files/Eyeliner_-Straight-Outta-Patience-2024.webp?v=1757996681"
                alt="eyeliner"
            ></a>
          </div>
          <div class="prpwebs-content-title-price-swiper">
            <div class="prpwebs-title-swiper">
              <a
                href="https://thelipbar.com/products/straight-line-eyeliner-sharpener-duo?variant=40895390416985"
                class="prpwebs-product-title"
                >Straight Line Eyeliner + Sharpener Duo</a
              >
              <span class="prpwebs-variant-title">Straight Outta Patience</span>
            </div>
            <div class="prpwebs-content-price-swiper">
              <div class="prpwebs-price-sw">
                <span class="money"> $12.00</span>
              </div>
            </div>
            <form action="/cart" class="add-upsell-items upsell-cart">
              <div class="prpwebs-variants-swipper">
                <div class="prpwebs-qty-upsell">
                  <div class="prpwebs-item-cart-content-quantity">
                    <div class="prpwebs-item-cart-qty prpwebs-item-39962285736025 quantity center">
                      <div class="js-qty__adjust1 prpwebs-cart-plus-minus" data-quantity="1" data-id="40895390416985">
                        <div class="prpwebs-dec prpwebs-qty button js-qty__adjust_prpwebs js-qty__adjust--minus quantity__minus">
                          <span class="prpwebs-minus-symbol">-</span>
                        </div>
                         <label for="updates_39962286030937" class="visually-hidden">Quantity</label>
                        <input
                          type="text"
                          value="1"
                          class="text quantity js-qty__num quantity__input prpwebs-qty-inputbox"
                          data-id="40895390416985"
                          id="updates_39962286030937"
                          name="quantity"
                        >

                        <div class="prpwebs-inc prpwebs-qty button js-qty__adjust_prpwebs js-qty__adjust--plus quantity__plus">
                          <span class="prpwebs-plus-symbol">+</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="prpwebs-upsell-add">
                <button type="button" name="id" class="prpwebs-upsell-add-to-cart" data-product-id="40895390416985">
                  <span class="prpwebs-add--to--cart">Add</span>
                  <span class="prpwebs--loading">
                    <i class="fa fa-circle-o fa-spin fa-1x fa-fw margin-bottom"></i>
                  </span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- End Straight Line Eyeliner + Sharpener Duo Product -->
    <!-- Total Meltdown Makeup Remover Balm Product -->
    <div class="prpwebs-products-dynamic-stacked">
      <div class="prpwebs-swiper-slide">
        <div class="prpwebs-content-product-slide-cart">
          <div class="prpwebs-product-content-image-swipper">
            <a href="https://thelipbar.com/products/total-meltdown-makeup-remover-balm"
              ><img
                class="prpwebs-cart-image"
                src="https://cdn.shopify.com/s/files/1/1919/5103/files/skincare_totalmeltdown_1_2_1_150x.jpg?v=1715575928"
                alt="Total Meltdown Remover Balm"
            ></a>
          </div>
          <div class="prpwebs-content-title-price-swiper">
            <div class="prpwebs-title-swiper">
              <a
                href="https://thelipbar.com/products/total-meltdown-makeup-remover-balm"
                class="prpwebs-product-title"
                >Total Meltdown Makeup Remover Balm</a
              >
              <span class="prpwebs-variant-title"></span>
            </div>
            <div class="prpwebs-content-price-swiper">
              <div class="prpwebs-price-sw">
                <span class="money"> $16.00</span>
              </div>
            </div>
            <form action="/cart" class="add-upsell-items upsell-cart">
              <div class="prpwebs-variants-swipper">
                <div class="prpwebs-qty-upsell">
                  <div class="prpwebs-item-cart-content-quantity">
                    <div class="prpwebs-item-cart-qty prpwebs-item-32329469100121 quantity center">
                      <div class="js-qty__adjust1 prpwebs-cart-plus-minus" data-quantity="1" data-id="7214408826969">
                        <div class="prpwebs-dec prpwebs-qty button js-qty__adjust_prpwebs js-qty__adjust--minus quantity__minus">
                          <span class="prpwebs-minus-symbol">-</span>
                        </div>
                         <label for="updates_32329469100121" class="visually-hidden">Quantity</label>
                        <input
                          type="text"
                          value="1"
                          class="text quantity js-qty__num quantity__input prpwebs-qty-inputbox"
                          data-id="7214408826969"
                          id="updates_32329469100121"
                          name="quantity"
                        >

                        <div class="prpwebs-inc prpwebs-qty button js-qty__adjust_prpwebs js-qty__adjust--plus quantity__plus">
                          <span class="prpwebs-plus-symbol">+</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="prpwebs-upsell-add">
                <button type="button" name="id" class="prpwebs-upsell-add-to-cart" data-product-id="7214408826969">
                  <span class="prpwebs-add--to--cart">Add</span>
                  <span class="prpwebs--loading">
                    <i class="fa fa-circle-o fa-spin fa-1x fa-fw margin-bottom"></i>
                  </span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- End Total Meltdown Makeup Remover Balm Facts Product -->
    <!-- Sample Product -->
    <!--<div class="prpwebs-swiper-slide">
      <div class="prpwebs-content-product-slide-cart">
        <div class="prpwebs-product-content-image-swipper">
          <a href="https://thelipbar.com/products/sample-just-a-tint-3-in-1-tinted-skin-moisturizer"
            ><img
              class="prpwebs-cart-image"
              src="https://cdn.shopify.com/s/files/1/1919/5103/files/sample_carameldelight1_720x_25ea3d96-9a3f-4dba-93b8-1cf4d5649b8c.jpg?v=1640764225"
              alt="Sample Caramel Delight"
          ></a>
        </div>
        <div class="prpwebs-content-title-price-swiper">
          <div class="prpwebs-title-swiper sample_cart_title">
            <a
              href="https://thelipbar.com/products/sample-just-a-tint-3-in-1-tinted-skin-moisturizer"
              class="prpwebs-product-title"
              >Try our Award Winning Tinted Moisturizer </a
            ><br>
            <span class="select_condition gt_america" style="font-weight: normal;"
              >Get 2 Free Tinted Moisturizer Samples</span
            >
          </div>
          <div class="prpwebs-content-price-swiper" style="display:none;">
            <div class="prpwebs-price-sw">
              <span class="money"> $0 </span>
            </div>
          </div>
          <form action="/cart" class="add-upsell-items upsell-cart">
            <div class="prpwebs-qty-upsell" style="display:none;">
              <div class="prpwebs-item-cart-content-quantity">
                <div class="prpwebs-item-cart-qty prpwebs-item- quantity center">
                  <div class="js-qty__adjust1 prpwebs-cart-plus-minus" data-quantity="1" data-id="">
                    {% comment %}
                      <div class="prpwebs-dec prpwebs-qty button js-qty__adjust_prpwebs js-qty__adjust--minus quantity__minus">
                        <span class="prpwebs-minus-symbol">-</span>
                      </div>
                    {% endcomment %}
                     <label for="updates_" class="visually-hidden">Quantity</label>
                    <input
                      type="text"
                      value="1"
                      class="text quantity js-qty__num quantity__input prpwebs-qty-inputbox"
                      data-id=""
                      id="updates_"
                      name="quantity"
                      name="quantity"
                      disabled
                      style="background:#fff;"
                    >
                    {% comment %}
                      <div class="prpwebs-inc prpwebs-qty button js-qty__adjust_prpwebs js-qty__adjust--plus quantity__plus">
                      	<span class="prpwebs-plus-symbol">+</span>
                      </div>
                    {% endcomment %}
                  </div>
                </div>
              </div>
            </div>

            <div class="prpwebs-variants-swipper sample_swatch_outer" style="margin-top:10px;">
              <div class="product-type-swatches__list sample-1">
                <a
                  class="VANILLA-BEAN shade-swatch"
                  href="javascript:void(0);"
                  style="background-image: url(https://cdn.shopify.com/s/files/1/1919/5103/files/VANILLA_BEAN_1.png?v=1669634810)"
                  data-product-id="40351630688345"
                  data-product-title="Vanilla Bean"
                  title="Vanilla Bean"
                >
                  <span style="display:none;" class="visuallyhidden" style="display:none">VANILLA BEAN</span>
                </a>
                <a
                  class="MY-FAIR-LADY shade-swatch  has-swatch is-selected"
                  href="javascript:void(0);"
                  style="background-image: url(https://cdn.shopify.com/s/files/1/1919/5103/files/ivory-concealer-my-fair-lady-go-off_60x_dba259f3-f509-484a-b9a8-317af3385cd6.jpg?60x60)"
                  data-product-id="40351630655577"
                  data-product-title="My Fair Lady"
                  title="My Fair Lady"
                >
                  <span style="display:none;" class="visuallyhidden" style="display:none">MY FAIR LADY</span>
                </a>
                <a
                  class="CHAI-TAI shade-swatch"
                  href="javascript:void(0);"
                  style="background-image: url(https://cdn.shopify.com/s/files/1/1919/5103/files/CHAI_TAI_1.png?v=1669634810)"
                  data-product-id="40351630622809"
                  data-product-title="Chai Tai"
                  title="Chai Tai"
                >
                  <span style="display:none;" class="visuallyhidden" style="display:none">CHAI TAI</span>
                </a>
                <a
                  class="BEIGE-BOMBSHELL shade-swatch"
                  href="javascript:void(0);"
                  style="background-image: url(https://cdn.shopify.com/s/files/1/1919/5103/files/honey-concealer-beige-bombshell-stay-ready_60x_9c482f6c-2fc9-4810-be5d-a6bde8d1165d.jpg?60x60)"
                  data-product-id="40351630590041"
                  data-product-title="Beige Bombshell"
                  title="Beige Bombshell"
                >
                  <span style="display:none;" class="visuallyhidden" style="display:none">BEIGE BOMBSHELL</span>
                </a>
                <a
                  class="ICED TOFFEE shade-swatch"
                  href="javascript:void(0);"
                  style="background-image: url(https://cdn.shopify.com/s/files/1/1919/5103/files/ICED_TOFFEE.jpg?v=1669634810)"
                  data-product-id="40351630557273"
                  data-product-title="Iced Toffee"
                  title="Iced Toffee"
                >
                  <span style="display:none;" class="visuallyhidden" style="display:none">ICED TOFFEE</span>
                </a>
                <a
                  class="CARAMEL-DELIGHT shade-swatch  has-swatch"
                  href="javascript:void(0);"
                  style="background-image: url(https://cdn.shopify.com/s/files/1/1919/5103/files/caramel-concealer-caramel-delight-boss-moves_60x_d6e0a1a5-389d-4a2a-8492-961ccd19e5e0.jpg?60x60)"
                  data-product-id="40351630524505"
                  data-product-title="Caramel Delight"
                  title="Caramel Delight"
                >
                  <span style="display:none;" class="visuallyhidden" style="display:none">CARAMEL DELIGHT</span>
                </a>
                <a
                  class="CINNA BAE shade-swatch"
                  href="javascript:void(0);"
                  style="background-image: url(https://cdn.shopify.com/s/files/1/1919/5103/files/CINNA_BAE_1.png?v=1669634810)"
                  data-product-id="40351630491737"
                  data-product-title="Cinna Bae"
                  title="Cinna Bae"
                >
                  <span style="display:none;" class="visuallyhidden" style="display:none">CINNA BAE</span>
                </a>
                <a
                  class="HONEY-DIP shade-swatch  has-swatch "
                  href="javascript:void(0);"
                  style="background-image: url(https://cdn.shopify.com/s/files/1/1919/5103/files/cinnamon-concealer-honey-dip-stuntin_60x_e6d1400d-9872-49b9-8ab7-f2f2fe334bdd.jpg?60x60)"
                  data-product-id="40351630458969"
                  data-product-title="Honey Dip"
                  title="Honey Dip"
                >
                  <span style="display:none;" class="visuallyhidden" style="display:none">HONEY DIP</span>
                </a>
                <a
                  class="ALMOND-JOY shade-swatch  has-swatch"
                  href="javascript:void(0);"
                  style="background-image: url(https://cdn.shopify.com/s/files/1/1919/5103/files/cinnamon-concealer-almond-joy-stuntin_60x_80f7e520-d987-4c5f-a1bf-69575b083e5d.jpg?60x60)"
                  data-product-id="40351630426201"
                  data-product-title="Almond Joy"
                  title="Almond Joy"
                >
                  <span style="display:none;" class="visuallyhidden" style="display:none">ALMOND JOY</span>
                </a>
                <a
                  class="MAHOGANY-MAMI shade-swatch  has-swatch"
                  href="javascript:void(0);"
                  style="background-image: url(https://cdn.shopify.com/s/files/1/1919/5103/files/mocha-concealer-mahogany-mami-vogue_60x_a46c016c-ebc9-4f47-a6e5-f55aefc977bf.jpg?60x60)"
                  data-product-id="40351630393433"
                  data-product-title="Mahogany Mami"
                  title="Mahogany Mami"
                >
                  <span style="display:none;" class="visuallyhidden" style="display:none">MAHOGANY MAMI</span>
                </a>
                <a
                  class="CHOCOLATE-CHIP shade-swatch  has-swatch"
                  href="javascript:void(0);"
                  style="background-image: url(https://cdn.shopify.com/s/files/1/1919/5103/files/mocha-concealer-chocolate-chip-vogue_60x_c7689c3a-0957-49e0-ad04-5a09137e5193.jpg?60x60)"
                  data-product-id="40351630360665"
                  data-product-title="Chocolate Chip"
                  title="Chocolate Chip"
                >
                  <span style="display:none;" class="visuallyhidden" style="display:none">CHOCOLATE CHIP</span>
                </a>
                <a
                  class="COCOA-BEAN shade-swatch  has-swatch"
                  href="javascript:void(0);"
                  style="background-image: url(https://cdn.shopify.com/s/files/1/1919/5103/files/ebony-concealer-cocoa-bean-squad-goals_60x_3384390c-e4e5-4d50-a4ec-a4868a820724.jpg?60x60)"
                  data-product-id="40351630327897"
                  data-product-title="Cocoa Bean"
                  title="Cocoa Bean"
                >
                  <span style="display:none;" class="visuallyhidden" style="display:none">COCOA BEAN</span>
                </a>
              </div>
              <span class="sample_select_1">My Fair Lady</span>
            </div>

            <div class="prpwebs-upsell-add" style="vertical-align: middle;">
              <button
                type="button"
                name="id"
                class="prpwebs-upsell-add-to-cart btn sample_add_button"
                data-product-id="39393805238361"
              >
                <span class="prpwebs-add--to--cart">Add</span>
                <span class="prpwebs--loading">
                  <i class="fa fa-circle-o fa-spin fa-1x fa-fw margin-bottom"></i>
                </span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div> -->
    <!-- End Sample Product -->  `;
  }

  if (type == "variant") {
    let checkvariant = itemSelected && itemSelected.includes(":");
    if (checkvariant) {
      let handle_with_variants = itemSelected.split(":");
      itemSelected = handle_with_variants[0];
      type = "variant";
      selvariantid = handle_with_variants[1];
    } else {
      type = "product";
    }
  }
  if(itemSelected){
    fetch(`/products/${itemSelected}.js`, { method: "GET" })
      .then((response) => {
        if (!response.ok) {
          const err = new Error("Not 2xx response");
          err.response = response;
          index = index + 1;
          if (index < 20)
            jsonCallShopify(suggestions, index, counterForCart, upsellHtml, type);
        } else {
          return response.json();
        }
      })
      .then((item) => {
        if (item) {
          console.log(item);
          counterForCart++;
          console.log(counterForCart, "counterdata");
          carp_url = item.url;
          carp_fImage = item.featured_image;
          carp_title = item.title;
          carp_vtitle = item.variants[0].name;
          carp_itemId = item.id;
          carp_itemVid = item.variants[0].id;
          carp_quantity = 1;
          carp_orginalPrice = Shopify.formatMoney(item.price);
          button_value = "Add";

          var filtervariants = item.variants.filter((data) => {
            return data.id == selvariantid;
          });

          if (type == "variant" && filtervariants && filtervariants.length > 0) {
            filtervariants = filtervariants[0];
            carp_title = filtervariants.title;
            //                      console.log(carp_title, 'testtitle');
            carp_title =
              carp_title.toLowerCase() == "default title"
                ? item.title
                : carp_title;
            carp_vtitle = filtervariants.title;
            carp_itemVid = filtervariants.id;
            carp_orginalPrice = Shopify.formatMoney(filtervariants.price);
            carp_fImage = filtervariants.featured_media.preview_image.src;
          }

          upsellHtml += `
                                  <div class="prpwebs-swiper-slide" style="display:none;">
                                    <div class="prpwebs-content-product-slide-cart">
                                      <div class="prpwebs-product-content-image-swipper">
                                        <a href="${carp_url}"><img class="prpwebs-cart-image" src="${carp_fImage}" alt=" ${carp_title} " /></a>
                                    </div>
                                    <div class="prpwebs-content-title-price-swiper">
                                      <div class="prpwebs-title-swiper">
                                        <a href="${carp_url}" class="prpwebs-product-title gt_america_bold"> ${carp_title}  </a>  
                                      </div>
                                    <div class="prpwebs-content-price-swiper">
                                          <div class="prpwebs-price-sw">
                                            <span class="money"> ${carp_orginalPrice} </span>
                                            </div>
                                    </div>`;

          upsellHtml += `<form action="/cart" class="add-upsell-items upsell-cart">
                                              <div class="prpwebs-variants-swipper">
                                                <div class="prpwebs-qty-upsell">
                                                  <div class="prpwebs-item-cart-content-quantity">  
                                                    <div class="prpwebs-item-cart-qty prpwebs-item-${carp_itemId} quantity center">
                                                      <div class="js-qty__adjust1 prpwebs-cart-plus-minus" data-quantity="{{ pitem.quantity}}" data-id="{{${carp_itemId}}}">
                                                        <div class="prpwebs-dec prpwebs-qty button js-qty__adjust_prpwebs js-qty__adjust--minus quantity__minus">
                                                          <span class="prpwebs-minus-symbol">-</span>
                                                        </div>
                                                          <label for="updates_${carp_itemVid}" class="visually-hidden">Quantity</label>
                                                        <input type="text" value="1" class="text quantity js-qty__num quantity__input prpwebs-qty-inputbox" data-id="${carp_itemVid}" id="updates_${carp_itemVid}" name="quantity" disabled style="background:#fff;">

                                                        <div class="prpwebs-inc prpwebs-qty button js-qty__adjust_prpwebs js-qty__adjust--plus quantity__plus">
                                                          <span class="prpwebs-plus-symbol">+</span>
                                                        </div>
                                                      </div>  
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>

                                              <div class="prpwebs-upsell-add">
                                                <button type="button" name="id" class="prpwebs-upsell-add-to-cart prpwebs-button-background-color btn" data-product-id="${carp_itemVid}">
                                                  <span class="prpwebs-add--to--cart gt_america_bold">${button_value}</span>
                                                  <span class="prpwebs--loading">
                                                    <i class="fa fa-circle-o fa-spin fa-1x fa-fw margin-bottom"></i>
                                                  </span>
                                                </button>
                                              </div>
                                            </form>
                                          </div>
                                        </div>
                                      </div>`;
          localStorage.setItem("upsellItemHtml", upsellHtml);
        }

        if (counterForCart < 4) {
          index = index + 1;
          upsellHtml = upsellHtml;
          if (index < 20)
            jsonCallShopify(suggestions, index, counterForCart, upsellHtml, type);
        } else {
          setTimeout(function () {
            insertupsellItems();
          }, 1000);
        }
      });
  }
}

//upsell item create after add to cart
function createupsellItem(cartitems) {
  let upsellItems = JSON.parse(localStorage.getItem("UpsellItems"));
  let filteritems = "";
  let itemHandle = "";
  let cartitemdata = "";
  upsellItems = upsellItems.upsellItems;

  let item = cartitems != undefined ? cartitems.items[0] : null;
  if (item != null && upsellItems.hasOwnProperty(item.handle)) {
    itemHandle = item.handle;
    filteritems = filterupsellitems(upsellItems, itemHandle, item.variant_id);
    if (filteritems) {
      if (filteritems[itemHandle].variants) {
        let productVariants = filteritems[itemHandle].variants;
        let VariantObject = productVariants[item.variant_id];
        // console.log("VariantObject", VariantObject);
        if (VariantObject) {
          let VariantSuggestion = VariantObject?.suggestions;
          suggestionString(VariantObject, cartitems?.items, "variant");
          //                     console.log('variant',VariantObject);
        } else {
          let ProductObject = filteritems[itemHandle];
          suggestionString(ProductObject, cartitems?.items, "product");
          //                   console.log('product121');
        }
      } else {
        let ProductObject = filteritems[itemHandle];
        suggestionString(ProductObject, cartitems.items, "product");
        //                 console.log('product12156');
      }
    }
  }
}

//upsell item filters
function filterupsellitems(object, data, vid) {
  const allowed = [data];
  const filtered = Object.keys(object)
    .filter((key) => allowed.includes(key))
    .reduce((obj, key) => {
      obj[key] = object[key];
      return obj;
    }, {});
  return filtered;
}

function suggestionString(SuggestionData, cartitemdata, type) {
  let suggestionString = SuggestionData.suggestions;
  let suggestions = (suggestionString || "").split("|");
  localStorage.setItem("currentUpsellItems", suggestionString);

  //all handles
  let extraUpsellItems = localStorage.getItem("productHandles");
  extraUpsellItems = (extraUpsellItems || "").replace(/['"]+/g, "");
  extraUpsellItems = extraUpsellItems.split("|");

  let allsuggestionsarray = suggestions.concat(extraUpsellItems);
  let newsuggestions = allsuggestionsarray.filter(
    (v, i, a) => a.indexOf(v) === i
  );

  localStorage.setItem("upsellItemHtml", " ");
  jsonCallShopify(newsuggestions, 0, 1, "", type);
}
